var map = {
	"./1_Felicitas Ernst_Ad_Quaker.webp": "./src/img/brands/quaker/1_Felicitas Ernst_Ad_Quaker.webp",
	"./FELICITAS_ERNST_QUAKERPAN QUAKER.webp": "./src/img/brands/quaker/FELICITAS_ERNST_QUAKERPAN QUAKER.webp",
	"./FELICITAS_ERNST_QUAKER__pizza= mesa sin harina = quaker.webp": "./src/img/brands/quaker/FELICITAS_ERNST_QUAKER__pizza= mesa sin harina = quaker.webp",
	"./Felicitas Ernst_Quaker_advertising_Publicidad_MG_1422.webp": "./src/img/brands/quaker/Felicitas Ernst_Quaker_advertising_Publicidad_MG_1422.webp",
	"./Felicitas Ernst_Quaker_advertising_Publicidad_MG_1431.webp": "./src/img/brands/quaker/Felicitas Ernst_Quaker_advertising_Publicidad_MG_1431.webp",
	"./Felicitas Ernst_Quaker_advertising_Publicidad_MG_1452.webp": "./src/img/brands/quaker/Felicitas Ernst_Quaker_advertising_Publicidad_MG_1452.webp",
	"./Felicitas Ernst_Quaker_advertising_Publicidad_MG_1468.webp": "./src/img/brands/quaker/Felicitas Ernst_Quaker_advertising_Publicidad_MG_1468.webp",
	"./Felicitas Ernst_Quaker_advertising_Publicidad_MG_1475.webp": "./src/img/brands/quaker/Felicitas Ernst_Quaker_advertising_Publicidad_MG_1475.webp",
	"./Felicitas Ernst_Quaker_advertising_Publicidad_MG_1477.webp": "./src/img/brands/quaker/Felicitas Ernst_Quaker_advertising_Publicidad_MG_1477.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/quaker sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";